// Shared Sankey layout constants — used by both SankeyChart.tsx and ProjectDetails.helper.ts
export const SANKEY_SVG_WIDTH = 1100;
export const SANKEY_SVG_HEIGHT = 550;
export const SANKEY_NODE_WIDTH = 25;
